import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  title: string;
  description?: string;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  add: (toast: Omit<Toast, 'id'>) => void;
  dismiss: (id: string) => void;
}

let counter = 0;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],

  add: (toast) => {
    const id = String(++counter);
    const duration = toast.duration ?? (toast.type === 'error' ? 6000 : 4000);

    set((s) => ({ toasts: [...s.toasts, { ...toast, id }] }));

    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, duration);
  },

  dismiss: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));

/** Shorthand helpers for firing toasts */
export const toast = {
  success: (title: string, description?: string) =>
    useToastStore.getState().add({ type: 'success', title, description }),
  error: (title: string, description?: string) =>
    useToastStore.getState().add({ type: 'error', title, description }),
  info: (title: string, description?: string) =>
    useToastStore.getState().add({ type: 'info', title, description }),
  warning: (title: string, description?: string) =>
    useToastStore.getState().add({ type: 'warning', title, description }),
};
